import FilterListGlobalList from 'common/pages/filter-list-global/FilterListGlobalList.tsx'

export const FilterListGlobalListAgency = (props: any) => <FilterListGlobalList {...props} agency />